import { FormControl } from "react-bootstrap";
import Validator from "../../services/Validator";
import { useEffect, useState } from "react";

const IbanField = ({x_account_iban, setIban}) => {
    
    const VALIDATOR = new Validator();
    const [fieldValue, setFieldValue] = useState(x_account_iban === "False"? "" : x_account_iban);
    const [originalValue, setOriginalValue] = useState();

    useEffect(() => {
        setOriginalValue(x_account_iban);
        if (x_account_iban !== "False") {
            setFieldValue(x_account_iban.substring(0).replace(/(.{4})(?!$)/g, '$1 '));
        }
    }, [])
    

    const onChangeHandler = (event) => {
        const inputValue = event.target.value;
        setIban(event.target.value.replace(/\s+/g, ''));
    
        // replace any characters that aren't digit or letter
        const formattedValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
    
        // group characters in 4 block
        const restFormatted = formattedValue.substring(0).replace(/(.{4})(?!$)/g, '$1 ');
    
        // set new value with uppercase
        setFieldValue(restFormatted.toUpperCase())
    }

    const isValidHandler = () => {        
        if (fieldValue.replace(/\s+/g, '') === originalValue || (originalValue === "False" && fieldValue === "")) return false;

        let valid = VALIDATOR.ibanValid(x_account_iban.replace(/\s+/g, ''));
        return valid;
    }

    return (
        <FormControl
            type="text"
            placeholder=""
            value={fieldValue}
            onChange={onChangeHandler}
            isValid={isValidHandler()}
        />
    )
}
export default IbanField;